angular.module('CarsSaraBo').controller('ErrorController', ['$translate', '$location', '$scope', '$rootScope', function ($translate, $location, $scope, $rootScope) {

    $scope.initialize = function () {
        $rootScope.hideProgressBar();
    }

    $scope.initialize();
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/error_controller.js
// module id = 900
// module chunks = 3